<script>
    import Snapshot from "@components/snapshot.vue";

    export default {
        components: {Snapshot },
        props: {
            camera: {
                type: Object,
                required: true
            }
        },
      data(){
        return {
          isOnline: true,
        };
      },
      computed: {
        cameraClass: function () {
          const classes = [
            this.$style.camera,
            (parseInt(this.$route.params.id) === parseInt(this.camera.id)) ? this.$style.active : '',
            (this.$parent.$parent.displayMode === 'minimal') ? this.$style.minimal : '',
          ];

          return classes;
        },
      },
        methods: {
          onLatestSnapshotTime(timestamp) {
            this.isOnline = ((new Date()).getTime() - timestamp) < 300000;
          }
        },
    }
</script>

<template>
    <BaseLink name="camera" :params="{ id: camera.uuid }" :class="cameraClass.join(' ')">
        <div :class="$style.cameraImage">
          <Snapshot :camera="camera" loading-size="50px" @latestSnapshotTime="onLatestSnapshotTime"></Snapshot>
        </div>
        <div :class="$style.cameraInfo">
            <h3><svg width="24" height="24" viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.128 0c1.026 0 1.862.803 1.862 1.791V3.57l3.664-1.752a.967.967 0 01.905.041.887.887 0 01.441.761v9.758c0 .31-.167.598-.441.762a.965.965 0 01-.905.04l-3.664-1.753v1.782c0 .988-.836 1.791-1.862 1.791H1.862C.836 15 0 14.197 0 13.209V1.791C0 .803.836 0 1.862 0zm0 1.791H1.862v11.418H15.13v-2.905a.854.854 0 01-.09-.365V5.058c0-.129.036-.25.09-.364l-.002-2.903zM12.13 9.474c.502 0 .908.353.908.79 0 .436-.406.789-.908.789H4.982c-.502 0-.908-.353-.908-.79 0-.436.406-.79.908-.79zm8.009-5.408L16.99 5.57v3.856l3.148 1.507V4.066z" fill="currentColor"/></svg>{{ camera.name }}</h3>
            <footer>
                <span v-if="camera.description" :class="$style.cameraDescription">{{ camera.description }}</span>
                <div>
                    <BaseStatus :class="$style.status" :online="isOnline"></BaseStatus>
                    <span v-if="camera.averageTemperature" :class="$style.cameraTemperature"> | Avg. Temp: {{ camera.averageTemperature.toFixed(0) }}&#8451;</span>
                </div>
            </footer>
            <div :class="$style.cameraArrow"><svg width="24" height="24" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.747.301A1.019 1.019 0 00.3.301a1.03 1.03 0 000 1.453L4.53 6 .3 10.246A1.03 1.03 0 001.023 12c.262 0 .524-.1.724-.301L6.7 6.726a1.033 1.033 0 000-1.452L1.747.3z" fill="currentColor"/></svg></div>
        </div>
    </BaseLink>
</template>

<style lang="scss" module>
    @import '@design';

    .camera {
        position: relative;
        display: flex;
        height: 90px;
        margin-bottom: 13px;
        text-decoration: none;
        background: $color-white;
        border-radius: 5px 5px 30px 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);

        @media (min-width: $breakpoint-sm) {
            height: 126px;
        }

        .cameraImage {
            display: none;
            height: 126px;
            text-align: center;
            background: $color-gray;
            border-radius: 5px 0 0 5px;

            @media (min-width: $breakpoint-sm) {
                display: flex;
                flex: 0 0 373px;
                align-content: center;
                justify-content: center;
            }
        }

        &.minimal {
            .cameraImage {
                display: none;
            }
        }

        .cameraInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 21px;

            @media (min-width: $breakpoint-sm) {
                padding: 21px 40px;
            }

            h3 {
                margin: 0;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: -0.59px;

                svg {
                    height: 15px;
                    margin-right: 7px;
                    color: $color-primary;
                }
            }

            .cameraDescription {
                display: block;
                margin-bottom: 4px;
                font-size: 14px;
                line-height: 19px;
                color: transparentize($color-text, 0.2);
                letter-spacing: -0.1px;
            }

            .cameraTemperature {
                font-size: 13px;
                color: transparentize($color-text, 0.45);
                letter-spacing: -0.09px;
            }

            .cameraArrow {
                position: absolute;
                right: 0;
                bottom: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 45px;
                height: 39px;
                color: $color-primary;
                border-top: 2px solid $color-gray-light;
                border-left: 2px solid $color-gray-light;
                border-radius: 5px 0 30px 0;

                svg {
                    height: 12px;
                }
            }
        }

        &.active,
        &:hover {
            background: $color-button-bg;
            background-image: $color-button-bg-gradient;
            box-shadow: none;

            .cameraInfo {
                h3 {
                    color: $color-white;

                    svg {
                        color: $color-white;
                    }
                }

                .cameraDescription {
                    color: $color-white;
                }

                .cameraTemperature,
                .status {
                    color: transparentize($color-white, 0.55)
                }

                .cameraArrow {
                    color: $color-white;
                    background: $color-primary;
                    border-color: $color-primary;
                }
            }
        }
    }
</style>
